
import { createContext, useContext, useState } from 'react';

const STORAGE_KEY = 'sidebar_collapsed';

const DrawerContext = createContext();

export const DrawerProvider = ({ children }) => {
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(() => {
        try { return localStorage.getItem(STORAGE_KEY) === 'true'; } catch { return false; }
    });

    const openDrawer = () => setDrawerOpen(true);
    const closeDrawer = () => setDrawerOpen(false);
    const toggleDrawer = () => setDrawerOpen(prev => !prev);
    const toggleCollapsed = () => setIsCollapsed(prev => {
        const next = !prev;
        try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
        return next;
    });

    return (
        <DrawerContext.Provider value={{ isDrawerOpen, openDrawer, closeDrawer, toggleDrawer, isCollapsed, toggleCollapsed }}>
            {children}
        </DrawerContext.Provider>
    );
};

export const useDrawer = () => {
    const context = useContext(DrawerContext);

    return context;
};
